import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onMounted, PropType, computed } from 'vue'
import { ApplicationGetters, IVacancy, LocalizationData, LocalizationPath, VacancyGetters } from '@tokyojob/core'
import {
  ButtonFactory,
  CButton,
  CIconFactory,
  CLabel,
  CVacancyImage,
  getLocalization,
  IconPlacement,
  IconSize,
  LabelFactory
} from '@tokyojob/frontend-components'
import { LocalizationService, VacancyCardText } from '../../../../../../../../core/src/modules'
import { getApplicationStore } from '@tokyojob/frontend-core'
import { getProvidedApp, getRouter } from '~/base/utils/provided-getter'


export default /*#__PURE__*/_defineComponent({
  __name: 'c-vacancy-card-small-map-mobile.component',
  props: {
  vacancyMap: {
    type: Object as PropType<IVacancy>,
    required: true
  }
},
  setup(__props) {

const props = __props;



const localization: LocalizationData = getLocalization(getProvidedApp())
const router = getRouter()

const image = ref(VacancyGetters.getThumbnailUrl(props.vacancyMap))
const category = VacancyGetters.getCategoryString(props.vacancyMap)
const categoryLabel = ref(LabelFactory.category(category, 'text-small theme-shades-light1-white'))
const title = ref(VacancyGetters.getTitle(props.vacancyMap))
const bonusText = props.vacancyMap.otherSalariesAndBonuses
  ? LocalizationService.t<string>(localization, LocalizationPath.performanceBonus)
  : ''
const link = ref(`/job/${props.vacancyMap.id}`)
const viewJobBtn = ButtonFactory.button({
  icon: CIconFactory.Icon({
    icon: 'briefcase',
    size: IconSize.small,
    placement: IconPlacement.Left,
    classes: 'text-big'
  }),
  label: LocalizationService.t<string>(localization, LocalizationPath.viewJobBtn),
  classes: 'row-start line-1 pl-8 p-5 g-7 align-center theme-blue-dark1-color-white br-7 text-small',
  link: { router, link: link.value }
})

const wage = [VacancyCardText.getMapFormattedWage(localization, props.vacancyMap)]
const wageLabel = ref(LabelFactory.wages(wage, bonusText, 'text-small theme-shades-light1-white'))
const languageLevel = ref(props.vacancyMap.japaneseConversation?.i18n![0].name!)
const languageLevelLabel = ref(
  LabelFactory.jpLevelSmall(languageLevel.value, 'text-small theme-shades-light1-white')
)

const applicationStore = getApplicationStore()
const hasApplied = computed(() => ApplicationGetters.hasApplied(props.vacancyMap.id!, applicationStore.values()))
const disabledOverlayClass = computed(() => (hasApplied.value ? 'disabled-overlay-div' : ''))
const appliedButtonProps = ButtonFactory.vacancyLinkButtonDisabled(localization, {
  link: { router: router, link: link.value }
})

watch(
  () => props.vacancyMap,
  (newValue: IVacancy) => {
    link.value = `/job/${newValue.id}`
    image.value = VacancyGetters.getThumbnailUrl(newValue)
    const category = VacancyGetters.getCategoryString(newValue)
    categoryLabel.value = LabelFactory.category(category, 'text-small theme-shades-light1-white')
    title.value = VacancyGetters.getTitle(newValue)
    const wage = [VacancyCardText.getMapFormattedWage(localization, newValue)]
    const bonusText = newValue.otherSalariesAndBonuses
      ? LocalizationService.t<string>(localization, LocalizationPath.performanceBonus)
      : ''
    wageLabel.value = LabelFactory.wages(wage, bonusText, 'text-small theme-shades-light1-white')
    languageLevel.value = newValue.japaneseConversation?.i18n![0].name!
    languageLevelLabel.value = LabelFactory.jpLevelSmall(languageLevel.value, 'text-small theme-shades-light1-white')
  }
)

onMounted(() => {
  link.value = `/job/${props.vacancyMap.id}`
})

return { __sfc: true,props, localization, router, image, category, categoryLabel, title, bonusText, link, viewJobBtn, wage, wageLabel, languageLevel, languageLevelLabel, applicationStore, hasApplied, disabledOverlayClass, appliedButtonProps, CButton, CLabel, CVacancyImage }
}

})